import { REDIRECT_URL_QUERY_PARAM } from '@constants/query-params';
import { Event, EventListItem } from '@domain/event';

import { createPreviewUrlWithoutQueryParams } from './create-preview-url-without-query-params';

export const createPreviewUrl = ({
  event,
  locale,
  defaultChannel,
  isWebView,
  isScheduledEvent,
}: {
  event: Event | EventListItem;
  locale: string;
  defaultChannel: string;
  isScheduledEvent?: boolean;
  isWebView?: boolean;
}): string => {
  if (!event) return '';
  if (!defaultChannel) return '';
  const isPublished = event.settings.isPublished && !event.settings.isHidden && !isScheduledEvent;
  const previewUrl = createPreviewUrlWithoutQueryParams({ defaultChannel, event, isPublished, locale });
  const queryParams = isWebView && !isPublished ? `?${REDIRECT_URL_QUERY_PARAM}=${window.location.href}` : '';
  return `${previewUrl}${queryParams}`;
};
